exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header .close {\r\n  display: none;\r\n}\r\n\r\nlabel {\r\n  font-size: 10pt;\r\n  font-weight: normal;\r\n  color: #444;\r\n}\r\n\r\ntextarea {\r\n  resize: none;\r\n  min-height: 100px;\r\n  width: 100%;\r\n}\r\n\r\n.overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5); \r\n  display: -webkit-box; \r\n  display: -ms-flexbox; \r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  color: white;\r\n  font-size: 1.5em;\r\n  z-index: 9999; \r\n}\r\n\r\n.spinner {\r\n  color: white;\r\n  font-size: 1.5em;\r\n  border: solid #eee 1px;\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  color: #aaa;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/detail-activity/detail-activity.component.css
// module id = 329
// module chunks = 0